/*
import "./legacy/jquery3";
import "./legacy/jquery_ujs";
import "./legacy/jquery-ui";
import "./legacy/jquery-ui/ui/widgets/autocomplete";
import "./legacy/jquery-ui/ui/widgets/sortable";
import "./legacy/jquery-textfill/source/jquery.textfill.min";
import "./legacy/jquery-colorbox/jquery.colorbox-min";
import "./legacy/jquery.browser";
import "./legacy/jquery.timeago";
import "./legacy/easyXDM/easyXDM";
import "./legacy/js.cookie";
import "./legacy/jquery.dotdotdot/dist/dotdotdot";
import "./legacy/jquery-file-upload/js/jquery.fileupload";
import "./legacy/jquery.downCount";
import "./legacy/fresh_url";
import "./legacy/fresh-url/dist/fresh_url.min";import 'jquery-ui/ui/widget'; 
import "./legacy/better-simple-slideshow";
import "./legacy/dropzone/dist/dropzone";
import "./legacy/popper";
import "./legacy/moment/moment";
import "./legacy/jquery.mixitup.min";
import "./legacy/bootstrap";
*/

import "./jquery-setup";
import "jquery-ui-dist/jquery-ui";
/*
import 'jquery-ui/ui/widget';
import "jquery-ui/ui/keycode"
import 'jquery-ui/ui/widgets/mouse';      // ✅ Provides $.ui.mouse
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/widgets/menu';
import 'jquery-ui/ui/widgets/autocomplete';
*/

import './legacy/jquery.textfill';
import './legacy/js-cookie';
import './legacy/jquery.mixitup.min.js';
import './legacy/jquery.colorbox-min.js';
//import "bootstrap-multiselect/dist/js/bootstrap-multiselect";
// app/assets/stylesheets/vendor/bootstrap-multiselect.css
// import "./legacy/multiselect";

import "blueimp-file-upload/js/jquery.fileupload"; // jquery fileupload

import 'popper.js';
import 'bootstrap';
import "./legacy/search";

import "./legacy/setup-dygraph";

import "./legacy/popover";
import "./legacy/ajax-spinner";
import "./legacy/jquery.timeago.js"
import "./legacy/timeago";
import "./legacy/type_preference";
import "./legacy/articles";
import "./legacy/column_selector";
import "./legacy/mobile";
import "./legacy/price_chart_common";
import "./legacy/price";
//import "./legacy/block";
import "./legacy/widget_price_compact";
import "./legacy/track";
import "./legacy/widget_deck";
import "./legacy/visual_deck";
import "./legacy/youtube_thumbs";
import "./legacy/spoiler_cards";
import "./legacy/layout";
import "./legacy/deck_search";
import "./legacy/decks";
import "./legacy/deck_techs";
import "./legacy/stripe-navigation";
import "./legacy/set_completion";
import "./legacy/privacy";
import "./legacy/dark";
import "./legacy/nested_forms";
import "./legacy/venatus_prosper";
import "./legacy/on_ready";
import "./legacy/scryfall_mappings";
